import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import StorePage from './components/StorePage';
import ProductPage from './components/ProductPage';
import DashboardPage from './components/DashboardPage';
import Login from './pages/login';
import CityPage from './pages/CityPage';
import Register from './pages/Register';
import AddProductPage from './pages/AddProductPage';
import CreateStorePage from './components/CreateStorePage';
import LaunchPage from './components/LaunchPage';
import EditProductPage from './components/EditProductPage';
import SearchResultsPage from './components/SearchResultsPage';
import Footer from './components/footer';
import ScrollToTop from './components/ScrollToTop';
import usePageTracking from './hooks/usePageTracking';
import AdminRoute from './components/admin/AdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import AdminOverview from './components/admin/AdminOverview';
import AdminStores from './components/admin/AdminStores';
import AdminStoreDetail from './components/admin/AdminStoreDetail';
import AdminUsers from './components/admin/AdminUsers';

function AppContent() {
  usePageTracking();
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        {/* Root path shows the launch page instead of homepage */}
        <Route path="/" element={<LaunchPage />} />

        {/* Keep the original homepage accessible at /home */}
        <Route path="/home" element={<HomePage />} />

        <Route path="/launch" element={<LaunchPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/city/:cityName" element={<CityPage />} />

        <Route path="/:city/:storeName" element={<StorePage />} />

        <Route path="/:city/:storeName/product/:productId" element={<ProductPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />

        {/* Keep the legacy search path working, but route both URLs to the same results page */}
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/search-results" element={<SearchResultsPage />} />

        <Route path="/dashboard/add" element={<AddProductPage />} />
        <Route path="/dashboard/edit/:productId" element={<EditProductPage />} />
        <Route path="/createstore" element={<CreateStorePage />} />

        {/* Admin dashboard */}
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<AdminOverview />} />
          <Route path="stores" element={<AdminStores />} />
          <Route path="stores/:id" element={<AdminStoreDetail />} />
          <Route path="users" element={<AdminUsers />} />
        </Route>
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
